<template>
  <div>
    <Head title="Create Command" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/commands/${bot}`">Commands</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.command" :error="form.errors.command" class="pb-8 pr-6 w-full lg:w-1/2" label="Command" />
          <text-input v-model="form.api_url" :error="form.errors.api_url" class="pb-8 pr-6 w-full lg:w-1/2" label="Url" />
          <text-input v-model="form.note" :error="form.errors.note" class="pb-8 pr-6 w-full lg:w-1/2" label="Note" />
          <label class="flex items-center mt-6 select-none" for="active">
            <input id="active" v-model="form.active" class="mr-1" type="checkbox" />
            <span class="text-sm">Active</span>
          </label>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Command</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        bot_id: window.location.pathname.split("/").slice(-2, -1)[0],
        command: null,
        api_url: null,
        note: null,
        active: false,
      }),
      bot: window.location.pathname.split("/").slice(-2, -1)[0],
    }
  },
  methods: {
    store() {
      this.form.post(`/commands/${this.bot}`)
    },
  },
}
</script>
